import axios from "axios";

const url = "https://memehub-server.herokuapp.com/memes";

export const fetchMemes = ()=>axios.get(url);

export const createMeme = (newMeme)=>axios.post(url, newMeme);

export const updateMeme = (id, updatedMeme)=>axios.patch(`${url}/${id}`, updatedMeme);

export const deleteMeme = (id)=>axios.delete(`${url}/${id}`);

export const laugh = (id)=>axios.patch(`${url}/${id}/laugh`);